const SportLogos = {
    MLB: "https://a.espncdn.com/i/teamlogos/leagues/500/mlb.png",
    NBA: "https://a.espncdn.com/i/teamlogos/leagues/500/nba.png",
    NFL: "https://a.espncdn.com/i/teamlogos/leagues/500/nfl.png",
    NHL: "https://a.espncdn.com/i/teamlogos/leagues/500/nhl.png"
};

export default SportLogos; 